export default __webpack_public_path__ + "static/media/bannerBottom2.cf3fb02e.jpg";